import React from 'react';
import { Link } from 'react-router-dom';
import './Privacy.css';

const FACTS = [
  'Community-powered safety reporting, not an emergency service',
  '100% anonymous — reports are never linked to your identity',
  'Community moderators review and verify every report',
  'Available free on iOS and Android',
  'No ads. No data selling. No tracking across apps.',
  'Built by Nikethana, a women\'s safety advocate based in San Francisco',
];

const STORE_LINKS = [
  {
    label: 'Google Play Store',
    url: 'https://play.google.com/store/apps/details?id=com.nikethana.safeher',
  },
  {
    label: 'Apple App Store',
    url: 'https://apps.apple.com/app/safeher/id6766123988',
  },
];

export default function Press() {
  return (
    <div className="privacy-page">
      <header className="privacy-header">
        <Link to="/" className="back-button">← SafeHer</Link>
        <h1>Press and Media</h1>
        <p>Resources for journalists, researchers, and partners</p>
      </header>

      <div className="privacy-content">

        <h2>About SafeHer</h2>
        <p>
          SafeHer is a community-powered safety reporting platform that helps women document and share
          safety incidents anonymously on a live map. Community moderators review every report to keep
          the feed accurate and trusted. SafeHer is not an emergency service.
        </p>

        <h2>Key facts</h2>
        <ul style={{ paddingLeft: '1.4rem', lineHeight: '2.2' }}>
          {FACTS.map((f, i) => <li key={i}>{f}</li>)}
        </ul>

        <h2>Founder</h2>
        <p>
          SafeHer was built by Nikethana, a women's safety advocate who has conducted 100+ street
          interviews across San Francisco, run election awareness campaigns, and worked at the
          intersection of policy and peer empowerment through organisations including Parity Lab
          and GenUp.
        </p>
        <p>
          <Link to="/about" style={{ color: '#00897B', fontWeight: 500 }}>Full founder story</Link>
        </p>

        <h2>Download the app</h2>
        <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', margin: '0.5rem 0 1.5rem' }}>
          {STORE_LINKS.map(({ label, url }) => (
            <a
              key={label}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                padding: '11px 22px',
                background: '#00897B',
                color: '#fff',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: 500,
                fontSize: '14px',
              }}
            >
              {label}
            </a>
          ))}
        </div>

        <h2>Logo and brand assets</h2>
        <p>
          For approved use of the SafeHer name, logo, and screenshots, email us at the press address
          below. Please do not alter the logo or use it in a way that implies endorsement without
          prior written consent.
        </p>

        <h2>Website</h2>
        <p>
          <a href="https://safeher.xyz" style={{ color: '#00897B', fontWeight: 500 }}>
            safeher.xyz
          </a>
        </p>

        <h2>Press contact</h2>
        <p>
          For media enquiries, interview requests, or partnership proposals, contact us at{' '}
          <a href="mailto:press@safeher.xyz" style={{ color: '#00897B', fontWeight: 500 }}>
            press@safeher.xyz
          </a>
          . We aim to respond within 2 business days.
        </p>

        <div className="privacy-last-updated">
          SafeHer · <a href="https://safeher.xyz">safeher.xyz</a>
        </div>
      </div>
    </div>
  );
}
